import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Download, Filter, Settings, Play, Pause, RefreshCw } from 'lucide-react'
import { toast } from '@/hooks/use-toast'

export const QuickActionsCard: React.FC = () => {
  const handleExport = () => {
    toast({
      title: "Export Started",
      description: "Your CSV export is being generated and will download shortly.",
    })
    // Simulate export
    setTimeout(() => {
      toast({
        title: "Export Complete",
        description: "leads_export.csv has been downloaded.",
      })
    }, 2000)
  }

  const handleAutoBlock = () => {
    toast({
      title: "Auto-Block Configured",
      description: "Risk scores above 80 will now be automatically blocked.",
    })
  }

  const handleRefresh = () => {
    toast({
      title: "Dashboard Refreshed",
      description: "Latest data has been loaded.",
    })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <Button 
            className="w-full justify-start" 
            variant="outline"
            onClick={handleExport}
          >
            <Download className="h-4 w-4 mr-2" />
            Export Current View
          </Button>
          
          <Button 
            className="w-full justify-start" 
            variant="outline"
          >
            <Filter className="h-4 w-4 mr-2" />
            Advanced Filters
          </Button>
          
          <Button 
            className="w-full justify-start" 
            variant="outline"
            onClick={handleAutoBlock}
          >
            <Play className="h-4 w-4 mr-2" />
            Configure Auto-Block
          </Button>
          
          <Button 
            className="w-full justify-start" 
            variant="outline"
            onClick={handleRefresh}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh Data
          </Button>
          
          <Button 
            className="w-full justify-start" 
            variant="outline"
          >
            <Settings className="h-4 w-4 mr-2" />
            Detection Settings
          </Button>
        </div>
        
        <div className="mt-6 p-3 bg-muted rounded-lg">
          <h4 className="font-medium text-sm mb-2">System Status</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Auto-Block:</span>
              <span className="text-green-600 font-medium">Active</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">ML Model:</span>
              <span className="text-green-600 font-medium">v2.3.1</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Last Update:</span>
              <span className="text-muted-foreground">2 min ago</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}